
interface Props
{
    message_content:string;
    html_content:string;
}

function Scroller({message_content,html_content}:Props){
    return (
        <div className="scroll-view">
          <p>{message_content}</p>
          <div dangerouslySetInnerHTML={{ __html: html_content }}></div>
        </div>
      );
}

export default Scroller